import Link from 'next/link';

export default function Policy() {
  return (
    <div className="text-center text-xs text-gray-500 leading-relaxed mt-2">
      By continuing, you agree to our{' '}
      <Link href="https://populateemr.com/end-user-terms" className="text-gray-700 hover:text-[#20B2AA] font-semibold text-xs" target="_blank">
        Terms of Service
      </Link>{' '}
      and{' '}
      <Link href="https://populateemr.com/privacy-policy" className="text-gray-700 hover:text-[#20B2AA] font-semibold text-xs" target="_blank">
        Privacy Policy
      </Link>
    </div>
  );
}
